import { Alignment, ModelRow } from "@mcleod/core";
import { AutogenLayoutEdiCustomerList } from "./autogen/AutogenLayoutEdiCustomerList";
import { Component, Label, TableRow, TableRowDisplayEvent } from "@mcleod/components";
import { CommonTooltips } from "@mcleod/common";


export class EdiCustomerList extends AutogenLayoutEdiCustomerList {
    override async onLoad() {
        this.switchRequiresCorrectionInd.allowIndeterminate = true;
        this.switchRequiresCorrectionInd.checked = undefined;
        this.switchHold214ForReply.allowIndeterminate = true;
        this.switchHold214ForReply.checked = undefined;
        this.switchCheckManualOrder.allowIndeterminate = true;
        this.switchCheckManualOrder.checked = undefined;
        this.sourceEdiCustomer.search();
        
    }

setTooltipContent(component: Component, modelRow: ModelRow) {
        const transactionType = modelRow.get("transaction_type");

        switch (transactionType) {
            case 'S':
                CommonTooltips.setTooltipContentLayout(component, null, "lme/datafusion/EdiProfileStatusQuickInfo", null,
                    {
                        "direction": modelRow.get("direction"),
                        "partner_id": modelRow.get("partner_id"),
                        "alt_partner_id": modelRow.get("alt_partner_id"),
                        "version": modelRow.get("version")
                    }
                );
                component.tooltipDynamicOptions = { position: Alignment.BOTTOM };
                return;
            case 'T':
                CommonTooltips.setTooltipContentLayout(component, null, "lme/datafusion/EdiProfileOrderQuickInfo", null,
                    {
                         "direction": modelRow.get("direction"),
                         "partner_id": modelRow.get("partner_id"),
                         "alt_partner_id": modelRow.get("alt_partner_id"),
                         "version": modelRow.get("version")
                    }
                );
                component.tooltipDynamicOptions = { position: Alignment.BOTTOM };
                return;
            case 'I':
                CommonTooltips.setTooltipContentLayout(component, null, "lme/datafusion/EdiProfileBillingQuickInfo", null,
                    {
                        "direction": modelRow.get("direction"),
                        "partner_id": modelRow.get("partner_id"),
                        "alt_partner_id": modelRow.get("alt_partner_id"),
                        "version": modelRow.get("version")
                    }
                );
                component.tooltipDynamicOptions = { position: Alignment.BOTTOM };
                return;        
        }
                   
    }

tableEdiCustomerOnRowDisplay(event: TableRowDisplayEvent) {
        
        const tableRow: TableRow = event.getTableRow();
        const row = (event.target as TableRow).data;
        const modelRow: ModelRow = tableRow.data as ModelRow;
        const rebillFilterComponent = tableRow.findComponentById("labelEdiCustomercreditRebillFilter") as Label;
        const requireCorrectionIndComponent = tableRow.findComponentById("labelEdiRequireCorrectionInd") as Label;
        const hold214Component = tableRow.findComponentById("labelEdiCustomerhold214ForReply") as Label;
        const manualOrderComponent = tableRow.findComponentById("labelEdiCustomercheckManualOrder") as Label;
        const partnerNameComponent = tableRow.findComponentById("labelPartnerName") as Label;
        this.setTooltipContent(partnerNameComponent, modelRow);

        switch (row.get("transaction_type")) {
            case "I":
                requireCorrectionIndComponent.text = (row.get("require_correction_ind") == "Y") ? "Yes":"No";
                hold214Component.text = "";
                manualOrderComponent.text = "";
                switch (row.get("credit_rebill_filter")) {
                    case "I":
                        rebillFilterComponent.text = "Invoices Only";
                        break;
                    case "O":
                        rebillFilterComponent.text = "Original Invoices Only";
                        break;
                    case "B":
                        rebillFilterComponent.text = "Invoices and Credits";
                        break;
                
                    }
                break;
            case "T":
                rebillFilterComponent.text = "";
                requireCorrectionIndComponent.text = "";
                hold214Component.text = "";
                manualOrderComponent.text = "";
                break;
            case "S":
                rebillFilterComponent.text = "";
                requireCorrectionIndComponent.text = "";
                hold214Component.text = (row.get("hold_214_for_reply") == "Y") ? "Yes":"No";
                manualOrderComponent.text = (row.get("check_manual_order") == "Y") ? "Yes":"No";
                break;
            default:
                rebillFilterComponent.text = "";
                requireCorrectionIndComponent.text = "";
                hold214Component.text = "";
                manualOrderComponent.text = "";
                break;
        }

    }
}
